import React from 'react';
import './Us.css'
import Typography from "@mui/material/Typography";
import {To, useNavigate} from "react-router-dom";

const Us = () => {

    const navigate = useNavigate();
    const handleNavigation = (path: To) => {
        navigate(path);
        window.scrollTo(0, 0);
    };

    return (
        <>
            <div className="contenedor">
                <div className="tarjeta">
                    <img src='/Assets/icons/grupo-de-hr.png' alt='grupo' style={{ height: '80px', marginBottom: '30px' }}/>
                    <Typography
                        sx={{
                            color: '#3b3b3b',
                            fontFamily: 'Inter, sans-serif',
                            fontSize: '1.5em',
                            fontWeight: '600',
                            marginBottom: '20px'
                        }}
                    >
                        Sentido social
                    </Typography>
                    <Typography
                        sx={{
                            color: '#656565',
                            fontFamily: 'Heebo, sans-serif',
                            fontSize: '1em',
                            fontWeight: '400',
                        }}
                    >
                        Ofrecemos productos y servicios que generan impacto social, diseñados para proteger a las personas más vulnerables y promover el desarrollo de nuestra comunidad.
                    </Typography>
                </div>

                <div className="tarjeta_centro">
                    <img src='/Assets/icons/equipo.png' alt='grupo' style={{ height: '100px', marginBottom: '20px' }}/>
                    <Typography
                        sx={{
                            color: '#ffffff',
                            fontFamily: 'Inter, sans-serif',
                            fontSize: '1.5em',
                            fontWeight: '600',
                            marginBottom: '20px'
                        }}
                    >
                        Equipo Profesional
                    </Typography>
                    <Typography
                        sx={{
                            color: '#ffffff',
                            fontFamily: 'Heebo, sans-serif',
                            fontSize: '1em',
                            fontWeight: '400'
                        }}
                    >
                        Contamos con un equipo de profesionales altamente calificado para asesorarte en la elección del seguro que mejor se adapte a tus necesidades.
                    </Typography>
                </div>

                <div className="tarjeta">
                    <img src='/Assets/icons/apoyo.png' alt='grupo' style={{ height: '80px', marginBottom: '30px' }}/>
                    <Typography
                        sx={{
                            color: '#3b3b3b',
                            fontFamily: 'Inter, sans-serif',
                            fontSize: '1.5em',
                            fontWeight: '600',
                            marginBottom: '20px'
                        }}
                    >
                        Soporte 24/7
                    </Typography>
                    <Typography
                        sx={{
                            color: '#656565',
                            fontFamily: 'Heebo, sans-serif',
                            fontSize: '1em',
                            fontWeight: '400',
                        }}
                    >
                        Línea de atención en cualquier momento, todos los días de la semana. Contacta con nosotros para cualquier duda o asistencia que necesites.                        
                    </Typography>
                </div>
            </div>

            <div className="us-container">
                <div className="left">
                    <img src="/Assets/riesgos.jpg" alt="Imagen" className="image"/>
                </div>
                <div className="right">
                    <div className="right-text">
                        <Typography
                            sx={{
                                color: '#ff6c00',
                                fontFamily: 'Inter, sans-serif',
                                fontSize: '15px',
                                letterSpacing: '3px',
                                fontWeight: 600,
                                textTransform: 'uppercase',
                                marginBottom: '5px'
                            }}
                        >
                            ¿Quiénes somos?
                        </Typography>
                        <Typography
                            sx={{
                                color: '#3b3b3b',
                                fontFamily: 'Inter, sans-serif',
                                fontSize: '43px',
                                fontWeight: '700',
                                marginBottom: '20px'
                            }}
                        >
                            Transformando Riesgos
                            en Tranquilidad
                        </Typography>
                        <Typography
                            sx={{
                                color: '#656565',
                                fontFamily: 'Heebo, sans-serif',
                                fontWeight: 400,
                                marginBottom: '30px',
                            }}
                        >
                            Con experiencia de más de 40 años, hemos perfeccionado el arte de brindar asesoramiento experto y atención personalizada. Cada cliente es único, y lo tratamos con la individualidad, importancia y el cuidado que merece.
                        </Typography>
                    </div>
                    
                    <div className="right-text-button">
                        <button className='us-button' onClick={() => handleNavigation('/Nosotros')}>
                            <span>Conoce más</span>
                        </button>
                    </div>

                </div>

            </div>
       </>
    );
};

export default Us;
